import http from "@/plugs/httpServer";
import { serverName } from "@wj/common";
let feather_campus = "feather-campus";

// 单列表查询
export function getByPage(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/itinerary/pageItinerary`,
    data: data,
  });
}
// 行程录入提交
export function scheduleInsert(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/itinerary/insertItinerary`,
    data: data,
  });
}
// 录入岗位提交
export function jobListInsert(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/job/insertJob`,
    data: data,
  });
}

// 编辑-行程录入提交
export function scheduleEdit(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/itinerary/editItinerary`,
    data: data,
  });
}
// 编辑-行程岗位提交
export function jobEdit(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/job/editJob`,
    data: data,
  });
}

// 获取岗位需求
export function getJobList(data: object) {
  return http({
    method: "GET",
    url: `${feather_campus}/position/getPosition`,
    params: data,
  });
}
//获取某个岗位详情
export function getJobDetail(data: object) {
  return http({
    method: "GET",
    url: `${feather_campus}/job/getJob`,
    params: data,
  });
}
// 根据行程itineraryId获取当前行程下的岗位列表
export function getScheduleJobList(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/job/listJob`,
    data: data,
  });
}
//删除行程
export function scheduleDelete(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/itinerary/deleteItinerary`,
    data: data,
  });
}
//结束行程
export function scheduleFinish(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/itinerary/overItinerary`,
    data: data,
  });
}

//删除行程
export function jobDelete(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/job/deleteJob`,
    data: data,
  });
}

// 行程发布 下架
export function schedulePublish(data: object) {
  return http({
    method: "GET",
    url: `${feather_campus}/itinerary/publish`,
    params: data,
  });
}

// 行程发布 下架
export function getPublishedItinerary(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/itinerary/pageCusItinerary`,
    data: data,
  });
}

export function pageWxCusItinerary(data: object) {
  return http({
    method: "POST",
    url: `${feather_campus}/itinerary/pageWxCusItinerary`,
    data: data,
  });
}


// 行程发布 下架
export function getItineraryDetail(data: object) {
  return http({
    method: "GET",
    url: `${feather_campus}/itinerary/getItinerary`,
    params: data,
  });
}
//获取用户名
export function getUsername(data: object) {
  return http({
    method: "GET",
    url: `${feather_campus}/resume/getResume`,
    params: data,
  });
}
